import React, { useState } from "react";
import EarlyAccess from "../components/app/common/EarlyAccess";
import Social, { ISocials } from "../components/app/common/Socials";
import FindJobLayout from "../components/app/layout/FindJobLayout";
import TrainingHero from "../components/app/training/TrainingHero";
import TrainingImpact from "../components/app/training/TrainingImpact";
import TwoCards from "../components/app/training/TwoCards";
import MeetTeam, { ITeamMember } from "../components/app/common/MeetTeam";
import { BlurFade } from "../components/app/BlurFade";
import LearningTestimonials from "../components/app/learning/LearningTestimonial";
import ContactFormModal from "../components/app/common/ContactModal";

const TrainingPage: React.FC = () => {
  const socialImages: string[] = [
    "/learning/socials/social-1.png",
    "/learning/socials/social-2.png",
    "/learning/socials/social-3.png",
    "/learning/socials/social-4.png",
    "/learning/socials/social-5.png",
  ];

  const socialLinks: ISocials[] = [
    {
      url: "/socials/social-facebook.svg",
      name: "Facebook",
      link: "https://www.facebook.com/share/1BUznhGuJb/?mibextid=wwXIfr",
    },
    {
      url: "/socials/social-instagram.svg",
      name: "Instagram",
      link: "https://www.instagram.com/dream.lms?igsh=NTgyd3dldHdhZmli",
    },
  ];

  const teamMembers: ITeamMember[] = [
    {
      name: "Shamsher Rayat",
      role: "Manager-Operation",
      description:
        "There are many variations of passages of Lorem Ipsum available",
      facebook: "/",
      twitter: "/",
      instagram: "/",
      image: "/images/samsher-rayat.png",
    },
    {
      name: "Puneet Suri",
      role: "Sr. Operation Executive",
      description:
        "There are many variations of passages of Lorem Ipsum available",
      facebook: "/",
      twitter: "/",
      instagram: "/",
      image: "/training/meet/puneet.png",
    },
    {
      name: "Paramjit Singh",
      role: "Sr. Operation Executive",
      description:
        "There are many variations of passages of Lorem Ipsum available",
      facebook: "/",
      twitter: "/",
      instagram: "/",
      image: "/images/paramjit-singh.png",
    },
    {
      name: "Jaijeet Singh",
      role: "Operation Executive",
      description:
        "There are many variations of passages of Lorem Ipsum available",
      facebook: "/",
      twitter: "/",
      instagram: "/",
      image: "/training/meet/jaijeet.png",
    },
    {
      name: "Ajay Kumar",
      role: "Project Manager",
      description:
        "There are many variations of passages of Lorem Ipsum available",
      facebook: "/",
      twitter: "/",
      instagram: "/",
      image: "/images/ajay-kumar.png",
    },
  ];
  const leftMember = {
    name: "Harish Ratnani",
    role: "Director",
    description:
      "Empowering Corporations, Teams & Startups | Training Solutions Expert | Corporate Trainer with Over 25 Years of Industry Experience.",
    linkedin: "http://linkedin.com/in/harish-ratnani-78013515",
    image: "/learning/meet/meet-1.png",
  };

  const [showContactModal, setShowContactModal] = useState<boolean>(false);

  const toggleShowContactModal = () => {
    setShowContactModal((prev) => !prev);
  };

  return (
    <div>
      <section
        className="p-5 sm:p-7 lg:p-10"
        style={{
          backgroundImage: "url(/skill/landing-hero.svg)",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        <BlurFade delay={0.25} inView>
          <TrainingHero />
        </BlurFade>
      </section>
      <BlurFade delay={0.25} inView>
        <section className="p-5 mb-16 mt-[8rem] md:mt-[13rem] xl:mt-[23rem] flex flex-col lg:flex-row  sm:px-10 md:px-24">
          <div className="flex flex-1 flex-col p-3 md:mb-10 lg:mb-0 md:flex-row gap-5 sm:gap-10 xl:pl-[2rem] justify-center items-center">
            <div className="justify-center hidden md:flex items-center md:w-56 xl:w-[26rem]">
              <img alt="" src="/dots.svg" className="w-56 xl:w-[26rem]" />
            </div>
            <div className="flex justify-center items-center lg:justify-normal lg:items-start h-full md:mb-0 lg:mb-0 lg:b-0">
              <div className="text-3xl sm:text-4xl lg:text-4xl xl:text-[3.8rem] max-w-sm  h-full flex flex-col ">
                <div className="leading-tight text-left">
                  Customized Training for Every Need
                </div>
                <div className="flex items-center justify-center w-full">
                  <p className="text-xs pt-2  lg:text-sm xl:text-lg lg:pt-4 xl:pt-6">
                    Our training programs are designed to empower professionals
                    with skills that matter. Whether it's mastering
                    industry-specific knowledge or refining leadership
                    capabilities, Dream Weavers has you covered:
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="flex xl:justify-start pt-5 lg:pt-0 h-full justify-center xl:flex-1">
            <div className="flex flex-col justify-between gap-5  lg:ml-20">
              <div className="grid gap-5 lg:gap-10">
                <div className="pl-7 py-2 lg:py-4 rounded-l-full bg-gradient-to-r from-[#B5E0FA] to-[#CEEEE900] to-40%">
                  <div className="lg:text-lg xl:text-xl">Domain Training</div>
                  <p className="text-xs max-w-[16rem] text-[#10124E]">
                    Industry-specific training to enhance technical expertise.
                  </p>
                </div>
                <div className="pl-7 py-2 lg:py-4 rounded-full text-[#10124E] bg-gradient-to-r from-[#c1e7ff]  to-[#CEEEE900] to-50%">
                  <div className="lg:text-lg xl:text-xl">
                    Compliance Training
                  </div>
                  <p className="text-xs max-w-[16rem] text-[#10124E]">
                    Keeping your workforce up-to-date with regulatory
                    standards.{" "}
                  </p>
                </div>
                <div className="pl-7 py-2 lg:py-4 rounded-full text-[#10124E] bg-gradient-to-r from-[#B5E0FA]  to-[#CEEEE900] to-65%">
                  <div className="lg:text-lg xl:text-xl">Leadership Skills</div>
                  <p className="text-xs max-w-[16rem] text-[#10124E]">
                    Cultivating effective and inspiring leaders for
                    tomorrow.{" "}
                  </p>
                </div>
                <div className="pl-7 py-2 lg:py-4 rounded-full text-[#10124E] bg-gradient-to-r from-[#B5E0FA]  to-[#CEEEE900] to-80%">
                  <div className="lg:text-lg xl:text-xl">Soft Skills</div>
                  <p className="text-xs max-w-[16rem] text-[#10124E]">
                    Sharpening interpersonal and communication abilities for
                    career growth.{" "}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </BlurFade>
      <BlurFade delay={0.25} inView>
        <section>
          {/* todo: add button url here */}
          <FindJobLayout
            title="We're Digitizing Training with Technology"
            description="We empower organizations, institutions, and communities with an industry-standard learning management system."
            buttonContent="Explore Dream LMS"
            buttonUrl="/learning"
            underlineUrl="/careers"
          />
        </section>
      </BlurFade>
      <BlurFade delay={0.25} inView>
        <section className="p-5 sm:p-7 lg:p-16 xl:px-28">
          <TrainingImpact />
        </section>
      </BlurFade>
      <BlurFade delay={0.25} inView>
        <section className="p-5 sm:p-7 lg:p-10">
          <TwoCards onOpenModal={toggleShowContactModal} />
        </section>
      </BlurFade>
      <BlurFade delay={0.25} inView>
        <section className="p-5 sm:p-7 lg:p-16 xl:px-28">
          <MeetTeam
            title="Meet the Skill Leaders at Dream Weavers!"
            description="There are many variations of passages of Lorem Ipsum available, but the majority have suffered in some form, by injected humour"
            teamMembers={teamMembers}
            leftMember={leftMember}
            hideDescription={true}
          />
        </section>
      </BlurFade>
      <section>
        <Social socialLinks={socialLinks} images={socialImages} />
      </section>
      <BlurFade delay={0.25} inView>
        <section className="p-5 sm:p-7 lg:p-16">
          <LearningTestimonials
            title="Don't just take our word for it!"
            smallDecription="See the feedback of our Clients"
          />
        </section>
      </BlurFade>
      <section
        className="px-5 sm:px-10 mt-10"
        style={{
          backgroundImage: "url('/home/early-access-bg.svg')",
        }}
      >
        <EarlyAccess />
      </section>
      <ContactFormModal
        isOpen={showContactModal}
        onClose={toggleShowContactModal}
      />
    </div>
  );
};

export default TrainingPage;
